import React, { useCallback, useState, useMemo, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { ToastContainer, toast } from 'react-toastify';
import useSupercluster from 'use-supercluster';
import mixpanel from 'mixpanel-browser';
import clsx from 'clsx';
import 'react-toastify/dist/ReactToastify.css';
import bbox from '@turf/bbox';
import hexGrid from '@turf/hex-grid';
import area from '@turf/area';
import intersect from '@turf/intersect';
import booleanDisjoint from '@turf/boolean-disjoint';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import union from '@turf/union';
import * as turf from '@turf/helpers';

import {
  Grid,
  CircularProgress,
  Card,
  CardContent,
  Paper,
  Collapse,
  Typography,
  CardMedia,
} from '@material-ui/core';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import LockSharpIcon from '@material-ui/icons/LockSharp';
import DownloadIcon from '@mui/icons-material/Download';
import DynamicDataCardLoading from 'src/App/HOC/Cards/DynamicDataCardLoading';
import FilterListIcon from '@material-ui/icons/FilterList';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';

import {
  Listing,
  Coordinates,
  ListViewData,
  MapActiveView,
  RevenueCalculatorValues,
  BarGraphData,
  PieChartData,
  LockedMarketSvgGraphsType,
  LockedMarketSvgGraphPerformanceDataType,
  LockedMarketSvgGraphPerformanceDataHighestLowestMetricsType,
  Listings,
  ListingVal,
  Neighbourhood,
  Submarket,
} from '../../../../interfaces/idashboard';
import { InsightsDashboardLegacyPropTypes, SearchProp } from '../../../../interfaces/iproptypes';
import { infoIconStyle } from '../styles/style';
import {
  KeyMetricsCard,
  PieDataCard,
  BarDataCard,
  DemandCard,
  SupplyCard,
  NeighbourhoodDataCard,
} from '../../../HOC/Cards';
import { Pointer, SimplePointer, TooltipCard, Top10ManagerCard } from '../../../HOC';
import { InfoTooltip } from '../../../HOC/Tooltips';
import {
  CustomSwitch,
  OutlinedRectangularButton,
  ViewDemoButton,
} from '../../../Components/Buttons';
import {
  processPolygon,
  getBoundedListings,
  safeMarkersLoad,
  getBoundedOTAListings,
  getAmenityDistribution,
  getDynamicExtraFees,
  getListViewData,
  convertCurrency,
  coordDistance,
  safeOTAMarkersLoad,
  formatCurrency,
  getListingCSVDataAsArray,
  makeDownloadableBlob,
  getVisibleListings,
  getVisibleOTAListings,
  applySmartBounds,
  makeLowerCase,
  isObject,
  formatGoogleMapsBounds,
  exportMarketOverview,
  exportSampleData,
  convertListingsIntoGeoJSONArray,
  convertBoundsObjToArray,
  mapOptions,
  bindBookingDataWithListings,
  getCancellationPolicyDistribution,
  findExtremePointsOverPolygon,
  getDemandByBookingTypeAndLead,
  getPreviewTextObj,
  calculateBounds,
  getGoogleMapBoundFormat,
  checkUserCountryAccessStatusWithMarket,
  trackUserDataVerificationAttempt,
  getHistoricalMarketPerformance,
} from 'src/utils/functions';
import {
  COLOR_PRIMARY,
  COLOR_PRIMARY_DARK,
  COLOR_PRIMARY_LIGHT,
  COLOR_ACCENT_1,
  COLOR_ACCENT_2,
  COLOR_YELLOW,
  POINTER_GREEN,
  COLOR_TOOLTIP_BACKGROUND,
  exchangeRates,
  sampleMarketTrendData,
  sampleMarket,
  COLOR_RANGE_AIRBNB_MARKERS,
  COLOR_AIRBNB_MARKERS,
  DOWNLOAD_CSV_LISTINGS_LTM_DATA,
  DOWNLOAD_CSV_KEY_METRICS,
  CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD,
  shortMonthNames,
  dummyBookingTypeBarGraphData,
  dummyBookingLeadBarGraphData,
  COLOR_RED_LIGHT,
  COLOR_RED,
} from 'src/const';
import { AlertBox } from 'src/App/Components';
import { LoadingCard } from '../../../HOC/Cards';
import { callApi } from 'src/core/callApi';
import Backdrop from '@mui/material/Backdrop';
import ConfirmUnlockRegionModal from 'src/App/Modals/ConfirmUnlockRegionModal';
import MapPointerRevRangeColorCard from 'src/App/HOC/Cards/MapPointerRevRangeColorCard';
import { MapListingCountInfoBox } from 'src/App/HOC/Alerts/MapListingCountInfoBoxAlert';
import { Button, Divider, LinearProgress, MenuItem, Select } from '@mui/material';
import _ from 'lodash';
import ClusterPointer from 'src/App/HOC/Pointer/ClusterPointer';
import IndividualOnBoardingPage from 'src/App/Pages/IndividualOnBoardingPage';
import { useDispatch } from 'react-redux';
import investmentLandingPage from 'src/App/assets/house-bg-home.jpg';
import { FullScreenAnimationLoader } from 'src/App/Components/Loaders';
import {
  COLOR_SECONDARY_2,
  COLOR_TERTIARY_1_400,
  COLOR_TERTIARY_1_300,
  COLOR_TERTIARY_1_200,
  COLOR_SECONDARY_2_600,
  COLOR_TERTIARY_1_500,
  COLOR_SECONDARY_1_300,
  COLOR_SECONDARY_1_600,
  COLOR_TEXT_3,
  COLOR_PRIMARY_2,
  COLOR_PRIMARY_1,
  COLOR_PRIMARY_1_600,
  COLOR_SECONDARY_1,
  NEIGHBOURHOOD_THEME,
} from 'src/colors';
import UnlockCTAButton from 'src/App/Components/Buttons/UnlockCTAButton';
import { dynamicDataAnimationZindex, dynamicDataZindex } from 'src/zIndex';
import TailoredRegionReDirectionPointer from 'src/App/HOC/Pointer/TailoredRegionReDirectionPointer';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  fetchDemoHistoryFromS3,
  getDistrictInfo,
  setHistoricalData,
} from 'src/store/Dashboard/actions';

import graphSvgDefaultRevenueImg from 'src/App/assets/graph_svg_default_revenue.jpg';
import graphSvgDefaultORImg from 'src/App/assets/graph_svg_default_occupancy_rate.jpg';
import graphSvgDefaultADRImg from 'src/App/assets/graph_svg_default_adr.jpg';
import { Search } from 'history';
import ToggleSwitch from 'src/App/Components/Buttons/ToggleSwitch';

const d3 = require('d3');
const ss = require('simple-statistics');
const classifyPoint = require('robust-point-in-polygon');

mixpanel.init('0c9d3451de8e0a1a2f21ec23b05c2063');

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardsContainer: {
      display: 'flex',
      flexDirection: 'column',
    },
    mapCardContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    mapTopRightToolbarContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 10,
    },
    mapContainer: {
      [theme.breakpoints.up('xs')]: {
        height: 580,
      },
      [theme.breakpoints.up(900)]: {
        height: 600,
      },
      position: 'relative',
      top: 0,
      left: 0,
    },
    mapTopToolbarContainer: {
      position: 'absolute',
      top: 10,
      left: '50%',
      transform: 'translateX(-50%)',
      paddingTop: 10,
      paddingBottom: 10,
      paddingLeft: 20,
      paddingRight: 20,
      backgroundColor: 'white',
      borderRadius: 20,
      color: COLOR_PRIMARY,
      fontWeight: 'bold',
      textTransform: 'capitalize',
      '&:hover': {
        color: COLOR_PRIMARY,
        backgroundColor: 'white',
        boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.2)',
      },
    },
    invisbleMarkerDataText: {
      fontSize: 14,
      fontWeight: 400,
      marginRight: 20,
    },
    digestCardContainer: {
      width: '33%',
      height: 150,
    },
    iconButton: {
      padding: 3,
    },
    toggleButton: {
      background: COLOR_TOOLTIP_BACKGROUND,
      '&:hover': {
        background: COLOR_PRIMARY_DARK,
        color: 'white',
      },
    },
    toggleButtonActive: {
      background: COLOR_PRIMARY_DARK,
      color: 'white',
      '&:hover': {
        background: COLOR_PRIMARY_DARK,
      },
    },
    tableRoot: {
      '& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer': {
        display: 'none',
      },
    },
    customButtonActive: {
      background: COLOR_PRIMARY_DARK + ' !important', //`radial-gradient(circle, hsla(189, 96%, 29%, 1) 0%, hsla(178, 100%, 38%, 1) 100%);`,
      borderRadius: 5,
      border: 0,
      color: 'white !important',
      height: 40,
      padding: '0 15px !important',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3) !important',
      '&:hover': {
        background: COLOR_PRIMARY_LIGHT + ' !important',
      },
    },
    customButton: {
      background: COLOR_RED + ' !important',
      borderRadius: 5,
      border: 0,
      color: 'white !important',
      height: 40,
      padding: '0 15px !important',
      boxShadow: '0 1px 1px 1px rgba(255, 255, 255, .3) !important',
      '&:hover': {
        background: COLOR_RED_LIGHT + ' !important',
      },
    },
  })
);

const ErrorStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const MAP_FILL_COLOR = POINTER_GREEN;

const InsightsDashboard = ({
  search,
  isUserAllowed,
  isLoggedIn,
  listings,
  otaListings,
  multipleMarkersCallLoading,
  multipleOTAMarkersCallLoading,
  titleCase,
  visibleListings,
  visibleOTAListings,
  sample,
  dashboardState,
  openAlert,
  setOpenAlert,
  setOTAListings,
  matches,
  filterApplied,
  setListings,
  dynamicTrigger,
  setDynamicTrigger,
  subscriptionModalOpen,
  setSubscriptionModalOpen,
  overviewDashboardMode,
  currency,
  user,
  showSearchCreditDeductWarningModal,
  setShowSearchCreditDeductWarningModal,
  searchLimitAlertBox,
  setSearchLimitAlertBox,
  getMarkers,
  handleOnSampleClick,
  bookingData,
  multipleBookingMarkersCallLoading,
  isHighlight,
  highlightElement,
  removeHighlightElement,
  filterVal,
  filterActive,
  setFilterActive,
  isEmailVerifyModalOpen,
  isUserVerified,
  setIsEmailVerifyModalOpen,
  rateLimitAlert,
  setRateLimitAlert,
  revPotentialRangeInvestment,
  getHighLowRevPotentialInvestment,
  bounds,
  setBounds,
  OnBoardingSearchBox,
  setIndividualRevenuePotentialRange,
  applyFilter,
  filteredListings,
  filteredOTAListings,
  setIsTailoredRegionOpen,
  updateShowAppTour,
  showAppTour,
  toggleDrawer,
  setLoginModalOpen,
}: InsightsDashboardLegacyPropTypes) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  let isDisabled: boolean = !isUserAllowed;
  let noSample: boolean = false;

  const redirectSearchPageQuery =
    new URLSearchParams(window.location.search).get('searchPage') || '-1';

  if (!listings.loading && visibleListings.data && visibleListings.data.length < 1) {
    noSample = true;
  }

  const isLockedMarketInsightLoading = useSelector(
    state => (state as any).dashboard.lockedMarketInsightLoading
  );

  const [bookingDataBinded, setBookingDataBinded] = useState<boolean>(false);

  const [extraCreditDeductModal, setExtraCreditDeductModal] = useState<boolean>(false);
  const [fullExportAccess, setFullExportAccess] = useState<boolean>(false);

  const [extraExportCreditsLoading, setExtraExportCreditsLoading] = useState<boolean>(false);
  const [extraExportError, setExtraExportError] = useState<boolean>(false);

  // const [isBlackFridayAlertOn, setIsBlackFridayAlertOn] = useState<boolean>(false);
  const [zoom, setZoom] = useState<number>(12);
  const [mapCenter, setMapCenter] = useState<{ lat: number; lng: number }>({
    lat: search.data.lat,
    lng: search.data.lng,
  });

  const [mapAirbnbMarkersCount, setMapAirbnbMarkersCount] = useState<number>(0);
  const [mapOTAMarkersCount, setMapOTAMarkersCount] = useState<number>(0);

  const [isDownloadOptionOpen, setIsDownloadOptionOpen] = useState<boolean>(false);

  const [clusterMarkers, setClusterMarkers] = useState<(JSX.Element | undefined)[] | null>(null);

  const [centerPointBounds, setCenterPointBounds] = useState<{
    north: Coordinates;
    east: Coordinates;
    south: Coordinates;
    west: Coordinates;
  } | null>(null);
  const [isTailoredRegionAnimationShown, setIsTailoredRegionAnimationShown] = useState<boolean>(
    false
  );

  const [
    confirmSaveCountryPlanMarketModalOpen,
    setConfirmSaveCountryPlanMarketModalOpen,
  ] = useState<boolean | undefined>(false);

  const [lockedMarketSvgGraphLoadingStatus, setLockedMarketSvgGraphLoadingStatus] = useState<
    'loading' | 'success' | 'failed'
  >('failed');
  const [
    lockedMarketSvgGraph,
    setLockedMarketSvgGraph,
  ] = useState<LockedMarketSvgGraphsType | null>(null);
  const [
    lockedMarketSvgGraphPerformanceData,
    setLockedMarketSvgGraphPerformanceData,
  ] = useState<LockedMarketSvgGraphPerformanceDataType | null>(null);

  const NEIGHBOURHOOD_IDEAL_sAMPLE_SIZE = 50;
  const [mapCopy, setMapCopy] = useState(null);
  const [mapsCopy, setMapsCopy] = useState(null);
  const [mapMode, setMapMode] = useState('Listings');
  const [submarketPolygonReferences, setSubmarketPolygonReferences] = useState<any>([]);
  const [neighbourhoodChoroplethLegends, setNeighbourhoodChoroplethLegends] = useState<any>({});
  const [hoveredNeighbourhoodPosX, setHoveredNeighbourhoodPosX] = useState<any>(null);
  const [hoveredNeighbourhoodPosY, setHoveredNeighbourhoodPosY] = useState<any>(null);
  const [hoveredNeighbourhood, setHoveredNeighbourhood] = useState<Submarket | null>(null);
  const neighbourhoodTooltipWidth = 450;
  const neighbourhoodTooltipHeight = 300;

  const warningToastRef = useRef<React.ReactText | undefined>(undefined);

  const isTailoredRegionButtonAnimationVisible =
    centerPointBounds && !multipleMarkersCallLoading && !multipleBookingMarkersCallLoading;

  const pathname = window.location.pathname;

  useEffect(() => {
    if (!isUserAllowed) {
      setBookingDataBinded(true);
      return;
    }

    if (
      !multipleMarkersCallLoading &&
      !multipleBookingMarkersCallLoading &&
      listings.data &&
      bookingData.data
    ) {
      setBookingDataBinded(false);
      const bindedListings = bindBookingDataWithListings(listings.data, bookingData.data);
      setListings(bindedListings);
      setBookingDataBinded(true);
    }
  }, [multipleMarkersCallLoading, multipleBookingMarkersCallLoading, isUserAllowed]);

  const { clusters } = useSupercluster({
    points: convertListingsIntoGeoJSONArray(
      visibleListings.data ? visibleListings.data : [],
      []
      // visibleOTAListings.data ? visibleOTAListings.data : []
    ),
    // @ts-ignore
    bounds: convertBoundsObjToArray(bounds),
    zoom,
    options: { radius: 75, maxZoom: 14 },
  });

  const makeClusterMarkers = () => {
    let clusteredMarkers: any[] = [];
    if (clusters && clusters.length > 0) {
      clusteredMarkers = clusters.map(cluster => {
        const [longitude, latitude] = cluster.geometry.coordinates;
        const { point_count: totalListingsNumInThisCluster } = cluster.properties;

        if (totalListingsNumInThisCluster > 0) {
          const pointSize: number =
            20 +
            (totalListingsNumInThisCluster /
              (visibleListings.data ? visibleListings.data.length : 0)) *
              40;

          return (
            <ClusterPointer
              key={`listing-cluster-${cluster.id}`}
              id={cluster.id}
              lat={latitude}
              lng={longitude}
              pointSize={pointSize}
              totalListingsNumInThisCluster={totalListingsNumInThisCluster}
            />
          );
        }
        return;
      });
    }

    setClusterMarkers(_ => clusteredMarkers);
  };

  const updateSVGGraphLTMlabel = (
    labelParentELement: SVGElement,
    labelData: LockedMarketSvgGraphPerformanceDataHighestLowestMetricsType,
    key: string,
    directon: 'highest' | 'lowest',
    color: string
  ) => {
    if (labelParentELement) {
      labelParentELement.innerHTML = `
        <text 
          x="10" 
          y="50" 
          dx="${Math.min(((labelData[key].arr_index ? labelData[key].arr_index : 0) * 8) / 2, 70)}%"
          dy="${directon === 'highest' ? -26 : 215}" 
          fill="${color}" 
          font-size="30" 
          font-family="Roboto" 
          id="text_1"
        >${shortMonthNames[Number(labelData[key].month.split('-')[1]) - 1]}: ${
        exchangeRates[currency].symbol
      }${formatCurrency(String(convertCurrency(currency, Number(labelData[key].value))))}
        </text>`;
    }
  };

  const updateAllSVGGraphLTMlabels = () => {
    const ADRDemoGraphHeighestValue = document.querySelector(
      '#svg_graph_nightly_rate svg g #text_1'
    ) as SVGElement;
    const ADRDemoGraphLowestValue = document.querySelector(
      '#svg_graph_nightly_rate svg g #text_2'
    ) as SVGElement;

    const RevenueDemoGraphHeighestValues = document.querySelector(
      '#svg_graph_previous_month_revenue svg g #text_1'
    ) as SVGElement;
    const RevenueDemoGraphLowestValues = document.querySelector(
      '#svg_graph_previous_month_revenue svg g #text_2'
    ) as SVGElement;

    if (lockedMarketSvgGraphPerformanceData) {
      updateSVGGraphLTMlabel(
        ADRDemoGraphHeighestValue,
        lockedMarketSvgGraphPerformanceData.highestPerformanceMetrics,
        'median_adr',
        'highest',
        COLOR_SECONDARY_2
      );
      updateSVGGraphLTMlabel(
        ADRDemoGraphLowestValue,
        lockedMarketSvgGraphPerformanceData.lowestPerformanceMetrics,
        'median_adr',
        'lowest',
        COLOR_SECONDARY_2
      );
      updateSVGGraphLTMlabel(
        RevenueDemoGraphHeighestValues,
        lockedMarketSvgGraphPerformanceData.highestPerformanceMetrics,
        'median_revenue',
        'highest',
        COLOR_PRIMARY_1
      );
      updateSVGGraphLTMlabel(
        RevenueDemoGraphLowestValues,
        lockedMarketSvgGraphPerformanceData.lowestPerformanceMetrics,
        'median_revenue',
        'lowest',
        COLOR_PRIMARY_1
      );
    }
  };

  useEffect(() => {
    lockedMarketSvgGraphLoadingStatus === 'success' && updateAllSVGGraphLTMlabels();
  }, [currency, lockedMarketSvgGraphLoadingStatus]);

  useEffect(() => {
    if (mapMode != 'Listings') {
      setClusterMarkers(_ => []);
    } else {
      makeClusterMarkers();
    }
  }, [listings, visibleListings, multipleBookingMarkersCallLoading, mapMode]);

  useEffect(() => {
    if (!search.loading && search.data) {
      setBounds(search.data.bounds);
      setMapCenter({ lat: search.data.lat, lng: search.data.lng });
    }
  }, [search]);

  const isSampleRegion = search && makeLowerCase(search.data.name) === sampleMarket;
  // useEffect(() => {
  //   if (isSampleRegion) {
  //     highlightElement('searchBar');
  //   } else {
  //     removeHighlightElement('searchBar');
  //   }
  // }, [search.data.name]);

  useEffect(() => {
    if (visibleListings.data?.length !== 0 && warningToastRef && warningToastRef.current) {
      toast.dismiss(warningToastRef.current);
    }
  }, [warningToastRef, visibleListings]);

  const [memoisedListings, memoisedOTAListings] = useMemo(() => {
    // if (listings.loading || otaListings.loading) {
    //   return [{}, {}];
    // }

    if (listings.loading) {
      return [{}, {}];
    }

    let updatedListings = {};
    let updatedOTAListings = {};

    const tempBoundedListings: string[] = bounds ? getBoundedListings(listings.data, bounds) : [];
    const visibleListings = new Set(
      getVisibleListings(
        tempBoundedListings,
        filteredListings ? filteredListings : tempBoundedListings
      )
    );

    Object.keys(listings.data).forEach(listingID => {
      updatedListings[listingID] = {
        ...listings.data[listingID],
        visible: visibleListings.has(listingID) ? true : false,
      };
    });

    const tempBoundedOTAListings = bounds ? getBoundedOTAListings(otaListings.data, bounds) : [];
    const visibleOTAListings = new Set(
      getVisibleOTAListings(
        tempBoundedOTAListings,
        filteredOTAListings ? filteredOTAListings : tempBoundedOTAListings
      )
    );
    Object.keys(otaListings.data).forEach(listingID => {
      updatedOTAListings[listingID] = {
        ...otaListings.data[listingID],
        visible: visibleOTAListings.has(listingID) ? true : false,
      };
    });
    return [updatedListings, updatedOTAListings];
  }, [bounds]);

  useEffect(() => {
    setListings(memoisedListings);
    setOTAListings(memoisedOTAListings);
  }, [memoisedListings, memoisedOTAListings]);

  const handleMapChange = useCallback(
    ({ center, bounds, zoom }: GoogleMapReact.ChangeEventValue) => {
      setDynamicTrigger(true);
      setTimeout(() => {
        setDynamicTrigger(false);
      }, 500);
      const lat1: number = center.lat;
      const lng1: number = center.lng;
      const lat2: number = search.data.lat;
      const lng2: number = search.data.lng;

      const distance: number = coordDistance(lat1, lng1, lat2, lng2);

      if (distance > 1500) {
        setSearchLimitAlertBox(true);
      } else {
        setSearchLimitAlertBox(false);
      }

      const boundsObj = formatGoogleMapsBounds(bounds);
      setBounds(boundsObj);
      setZoom(zoom);
      setMapCenter({ lat: center.lat, lng: center.lng });
    },
    [bounds]
  );

  // const handleMapChangeDebounced = _.debounce(handleMapChange, 50);

  const setPolygon = (
    map,
    maps,
    paths: Coordinates[][],
    strokeColor: string,
    fillColor: string,
    strokeOpacity = 0.8,
    strokeWeight = 2,
    fillOpacity = 0.12,
    showTooltip = false,
    marketInfo: Submarket | null = null
  ) => {
    const polygon = new maps.Polygon({
      paths: paths,
      strokeColor: strokeColor,
      strokeOpacity: strokeOpacity,
      strokeWeight: strokeWeight,
      fillColor: fillColor,
      fillOpacity: fillOpacity,
    });
    polygon.setMap(map);

    if (showTooltip && marketInfo) {
      let isMouseOver = false;
      let bufferTimeout;

      maps.event.addListener(polygon, 'mouseover', function(e) {
        const mapContainer = map.getDiv();
        const { x, y, width, height } = mapContainer.getBoundingClientRect();
        const { clientX, clientY } = e.domEvent;
        const buffer = 20;

        const posY = clientY - y;
        const posX = clientX - x;

        // Calculate adjusted positions to ensure the tooltip is within the map boundary
        let adjustedPosX = posX;
        let adjustedPosY = posY;

        if (adjustedPosX + neighbourhoodTooltipWidth > width) {
          adjustedPosX = width - neighbourhoodTooltipWidth - buffer;
        }

        if (adjustedPosY + neighbourhoodTooltipHeight > height) {
          adjustedPosY = height - neighbourhoodTooltipHeight - buffer;
        }

        // Adjust based on the viewport height
        if (adjustedPosY < 0) {
          adjustedPosY = 0;
        } else if (adjustedPosY + neighbourhoodTooltipHeight > window.innerHeight - y) {
          adjustedPosY = window.innerHeight - y - neighbourhoodTooltipHeight - buffer;
        }

        bufferTimeout = setTimeout(() => {
          setHoveredNeighbourhoodPosX(adjustedPosX);
          setHoveredNeighbourhoodPosY(adjustedPosY);
          setHoveredNeighbourhood(marketInfo);
        }, 200);

        isMouseOver = true;
      });

      // ensure that the neighbourhood tooltips are hidden when the cursor is over a non neighbourhood portion of the map
      maps.event.addListener(map, 'mousemove', function(e) {
        if (!isMouseOver) {
          clearTimeout(bufferTimeout);
          setHoveredNeighbourhoodPosX(null);
          setHoveredNeighbourhoodPosY(null);
          setHoveredNeighbourhood(null);
        }
      });
    }

    return polygon;
  };

  const getPolygonPaths = (polygonRaw: string, multiPolygonRaw: string) => {
    const polygonArr: Coordinates[][] = processPolygon(polygonRaw, multiPolygonRaw);
    let paths: Coordinates[][] = [];
    if (polygonArr.length > 0) {
      polygonArr.forEach((polygon: Coordinates[], _: number) => paths.push(polygon));
    }
    return paths;
  };

  const apiIsLoaded = (map, maps, polygonRaw: string, multiPolygonRaw: string) => {
    // Define the LatLng coordinates for the polygon's path.
    const paths = getPolygonPaths(polygonRaw, multiPolygonRaw);
    const polygon = setPolygon(map, maps, paths, COLOR_PRIMARY_DARK, MAP_FILL_COLOR);

    // ensure that the neighbourhood tooltips are hidden when the cursor is over a non neighbourhood portion of the map
    maps.event.addListener(polygon, 'mouseover', function(e) {
      setHoveredNeighbourhoodPosX(null);
      setHoveredNeighbourhoodPosY(null);
      setHoveredNeighbourhood(null);
    });

    applySmartBounds(map, maps, bounds, [], zoom, mapCenter);
    const extremePoints = findExtremePointsOverPolygon(paths[0]);
    setCenterPointBounds(extremePoints);

    const newBounds = calculateBounds(paths);
    const newBoundsObj = {
      northEast: { lat: newBounds.maxLat, lng: newBounds.minLng },
      southWest: { lat: newBounds.minLat, lng: newBounds.maxLng },
    };
    setBounds(newBoundsObj);
    map.fitBounds(getGoogleMapBoundFormat([newBoundsObj.northEast, newBoundsObj.southWest]));

    setMapCopy(map);
    setMapsCopy(maps);
    submarketPolygonSetRef.current = false;
  };

  const tailoredRegionRedirectionMarker = (
    point: { lat: number; lng: number },
    rotate: boolean
  ) => {
    if (!isTailoredRegionButtonAnimationVisible) return;

    return (
      <TailoredRegionReDirectionPointer
        lat={point.lat}
        lng={point.lng}
        rotate={rotate}
        tooltip={
          'Click here to edit and define a tailored market on the map. Customize your target region to focus on specific areas that matter to you and tailor your market analysis accordingly.'
        }
        onClickHandler={() => {
          window.history.pushState(
            {},
            '',
            window.location.search + `?lat=${point.lat}&lng=${point.lng}`
          );
          setIsTailoredRegionOpen(true);
        }}
      />
    );
  };

  const tailoredRegionRedirectionMarkers = useMemo(() => {
    if (!isTailoredRegionButtonAnimationVisible) return;

    return (
      centerPointBounds &&
      Object.keys(centerPointBounds).map(key =>
        tailoredRegionRedirectionMarker(
          centerPointBounds[key],
          key === 'east' || key === 'west' ? true : false
        )
      )
    );
  }, [centerPointBounds, isTailoredRegionButtonAnimationVisible]);

  // SET Tailored Region animation gone after 10 seconds
  useEffect(() => {
    let timeOut: any = null;
    if (isTailoredRegionButtonAnimationVisible) {
      timeOut = setTimeout(() => {
        setIsTailoredRegionAnimationShown(true);
      }, 10001);
    }

    return () => {
      timeOut && clearTimeout(timeOut);
    };
  }, [isTailoredRegionButtonAnimationVisible]);

  const getPointerColor = (
    isDisabled: boolean,
    item: Listing,
    revPotentialRangeInvestment: { [key: number]: 'visible' | 'hidden' } = {}
  ) => {
    if (!isDisabled && !item.revenuePotential) {
      return COLOR_AIRBNB_MARKERS;
    }

    if (isDisabled && item.revenuePercentileRating) {
      return COLOR_RANGE_AIRBNB_MARKERS[item.revenuePercentileRating];
    }

    // let resultColor = COLOR_RANGE_AIRBNB_MARKERS[0];
    const revPotentialRange = Object.keys(revPotentialRangeInvestment)
      .map(Number)
      .sort((a, b) => a - b);

    for (let i = 0; i < 4; i++) {
      const currentRevPotential: number = revPotentialRange[i];
      if (item.revenuePotential <= currentRevPotential) {
        return COLOR_RANGE_AIRBNB_MARKERS[i];
      }
    }

    return COLOR_RANGE_AIRBNB_MARKERS[0];
  };

  let markers = useMemo(() => {
    if (!visibleListings.loading) {
      const safeVisibleListings: Listing[] = safeMarkersLoad(visibleListings.data, isUserAllowed);
      setMapAirbnbMarkersCount(_ => safeVisibleListings.length);
      return safeVisibleListings.map((item: Listing, index: number) => {
        let color: string = getPointerColor(isDisabled, item, revPotentialRangeInvestment);

        return (<></>
          // <Pointer
          //   key={index}
          //   lat={item.latitude}
          //   lng={item.longitude}
          //   setSubscriptionModalOpen={setSubscriptionModalOpen}
          //   data={item}
          //   canDelete={true}
          //   setListings={setListings}
          //   listings={listings.data}
          //   isDisabled={item.markerType === 'full' ? false : true}
          //   currency={currency}
          //   subscriptionModalOpen={subscriptionModalOpen}
          //   multipleBookingMarkersCallLoading={multipleBookingMarkersCallLoading}
          //   color={color}
          //   market={search.data.name}
          // />
        );
      });
    }
    return;
  }, [visibleListings, currency, multipleBookingMarkersCallLoading, revPotentialRangeInvestment]);

  let otaMarkers = useMemo(() => {
    if (!otaListings.loading) {
      const safeVisibleOTAListings = safeOTAMarkersLoad(visibleOTAListings.data, isUserAllowed);
      setMapOTAMarkersCount(_ => safeVisibleOTAListings.length);

      return safeVisibleOTAListings.map((data, index) => (
        <SimplePointer lat={data.lat} lng={data.lng} data={data} />
      ));
    }
    return null;
  }, [visibleOTAListings, visibleListings, listings, otaListings]);

  const [stickOnScroll, setStickOnScroll] = useState<boolean>(false);
  useScrollPosition(
    ({ currPos }) => {
      const isSticky: boolean = currPos.y < -300;
      if (isSticky !== stickOnScroll) setStickOnScroll(isSticky);
    },
    [stickOnScroll]
  );

  const warningAlert = (text: string) =>
    (warningToastRef.current = toast.error(text, {
      autoClose: 500000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      draggablePercent: 60,
    }));
  const infoAlert = (text: string) =>
    toast.warning(text, {
      autoClose: 500000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      draggablePercent: 60,
    });

  const successAlert = (text: string) =>
    toast.success(text, {
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
      draggablePercent: 60,
    });

  useEffect(() => {
    setIndividualRevenuePotentialRange(revPotentialRangeInvestment);
  }, [revPotentialRangeInvestment]);

  // submarket analysis

  const generateHexGrid = (polygonRaw: string, multiPolygonRaw: string, listings: Listings) => {
    // transform polygon string to google maps polygon paths... [{lat: 0, lng: 0},{lat: 0, lng: 0},..]
    const paths = getPolygonPaths(polygonRaw, multiPolygonRaw);
    // transfrom google maps polygon paths to array of linear rings... [[0,0],[0,0],..]
    const coordinates = paths[0].map(coords => [coords.lng, coords.lat]);
    // transfrom array of linear rings to RFC Polygon feature
    const turfPolygon = turf.polygon([coordinates]);

    // logic to dynamically calculate hexagon size
    const marketArea = area(turfPolygon) * 0.000001; // sqkm
    const numberOfHexagons = Object.values(listings).length / 50;
    const areaOfEachHexagon = marketArea / numberOfHexagons;
    const hexSideLength = Math.sqrt((3 * areaOfEachHexagon) / (2 * Math.sqrt(3)));

    // created a boundary box from the polygon
    const boundaryBox = bbox(turfPolygon);
    // creates hexgrid inside the boundary box
    const hexagonalGrid = hexGrid(boundaryBox, hexSideLength);

    // Clip each hexagon based on the original polygon
    const clippedHexGrid = hexagonalGrid.features.map(hexagon => {
      const clippedHexagon = intersect(hexagon, turfPolygon);
      return clippedHexagon ? clippedHexagon.geometry.coordinates : null;
    });

    const validHexagons = clippedHexGrid.filter(hexagon => hexagon !== null);
    return validHexagons;
  };

  const submarketPolygonSetRef = useRef(false);

  useEffect(() => {
    if (
      multipleMarkersCallLoading ||
      !listings.data ||
      !mapCopy ||
      !mapsCopy ||
      search.loading ||
      (!search.data.polygon && !search.data.multiPolygon)
    )
      return;

    if (mapMode == 'Listings') {
      // remove subamrket polygons
      submarketPolygonReferences.forEach(submarketPolygon => submarketPolygon.setMap(null));
      submarketPolygonSetRef.current = false;
      return;
    }

    // check if submarket polygons are already set and avoid overlapping
    if (submarketPolygonSetRef.current) return;

    // explode the market map in hexagonal grids
    const hexGrid = generateHexGrid(search.data.polygon, search.data.multiPolygon, listings.data);

    // transform the hexagonal grid into neighbourhoods by setting listings count metadata
    const neighbourhoods = hexGrid.map(hexagon => {
      let listingsInHexagon: ListingVal[] = [];
      if (!hexagon)
        return {
          coordinates: [],
          listings: [],
        };

      Object.values(listings.data).forEach(listing => {
        const point = [listing.longitude, listing.latitude];
        if (classifyPoint(hexagon[0], point) === -1 || classifyPoint(hexagon[0], point) === 0)
          listingsInHexagon.push(listing);
      });

      return {
        coordinates: hexagon[0],
        listings: listingsInHexagon,
      };
    });

    const filteredNeighbourhoods = neighbourhoods.filter(
      neighbourhood => neighbourhood.listings.length > 0
    );

    // merge the neighbourhoods untill each neighbourhood has minimum half of the ideal listings count
    const neighbourhoodMergingMinThreshold = NEIGHBOURHOOD_IDEAL_sAMPLE_SIZE / 2;
    let spatialRelationships = establishSpatialRelationships(filteredNeighbourhoods);
    let mergedNeighbourhoods: any = filteredNeighbourhoods;
    let isFirstIteration = true;

    while (
      isFirstIteration ||
      mergedNeighbourhoods.some(
        (neighbourhood, index) =>
          neighbourhood.listings.length < neighbourhoodMergingMinThreshold &&
          spatialRelationships[index].length > 0
      )
    ) {
      mergedNeighbourhoods = bfsMergeHexagons(
        mergedNeighbourhoods,
        spatialRelationships,
        neighbourhoodMergingMinThreshold
      );
      spatialRelationships = establishSpatialRelationships(mergedNeighbourhoods);
      isFirstIteration = false;
    }

    // submarkets are ready
    const submarkets: Submarket[] = mergedNeighbourhoods.map((neighbourhood, index) => {
      const hexagonPath = neighbourhood.coordinates.map(coord => ({
        lng: coord[0],
        lat: coord[1],
      }));
      const medianOccupancyRate = getMedianOccupancyRate(neighbourhood.listings);
      return {
        ...neighbourhood,
        path: [hexagonPath],
        occupancyRate: medianOccupancyRate,
        id: index,
      };
    });

    // set vhropleth graph breaks and assign colors to submarkets
    const submarketOccupancyRates = submarkets.map(submarket => submarket.occupancyRate);
    const validSubmarketOccupancyRates = submarketOccupancyRates.filter(rate => rate !== undefined);
    const choroplethBreaks = getNaturalBreaks(validSubmarketOccupancyRates);
    const legends = {
      [`< ${choroplethBreaks[0] + 1}%`]: NEIGHBOURHOOD_THEME[0],
      [`${choroplethBreaks[0] + 1}% - ${choroplethBreaks[1]}%`]: NEIGHBOURHOOD_THEME[1],
      [`${choroplethBreaks[1] + 1}% - ${choroplethBreaks[2]}%`]: NEIGHBOURHOOD_THEME[2],
      [`${choroplethBreaks[2] + 1}% - ${choroplethBreaks[3]}%`]: NEIGHBOURHOOD_THEME[3],
      [`> ${choroplethBreaks[3]}%`]: NEIGHBOURHOOD_THEME[4],
    };
    setNeighbourhoodChoroplethLegends(legends);

    let submarketPolygons: any[] = [];

    submarkets.forEach(submarket => {
      const color = getSubmarketColor(submarket.occupancyRate, choroplethBreaks);
      const numberOfListings = submarket.listings.length;
      const submarketPolygon = setPolygon(
        mapCopy,
        mapsCopy,
        submarket.path,
        COLOR_PRIMARY_DARK,
        color,
        0.8,
        2,
        0.8,
        true,
        submarket
      );
      submarketPolygons.push(submarketPolygon);
    });

    setSubmarketPolygonReferences(submarketPolygons);

    submarketPolygonSetRef.current = true;
  }, [multipleMarkersCallLoading, listings, mapCopy, mapsCopy, mapMode, search]);

  const establishSpatialRelationships = hexagons => {
    const spatialRelationships = {};

    // Iterate through hexagons
    hexagons.forEach((hexagon1, index1) => {
      const neighbors: number[] = [];

      // Check each other hexagon for adjacency
      hexagons.forEach((hexagon2, index2) => {
        if (index1 !== index2) {
          // Check if hexagons share an edge or a vertex
          const sharedEdge = !booleanDisjoint(
            turf.polygon([hexagon1.coordinates]),
            turf.polygon([hexagon2.coordinates])
          );
          const sharedVertex = hexagon1.coordinates.some(coord =>
            booleanPointInPolygon(turf.point(coord), turf.polygon([hexagon2.coordinates]))
          );

          if (sharedEdge || sharedVertex) {
            neighbors.push(index2);
          }
        }
      });

      spatialRelationships[index1] = neighbors;
    });

    return spatialRelationships;
  };

  const bfsMergeHexagons = (unmergedHexagons, spatialRelationships, mergeThreshold) => {
    const hexagons = [...unmergedHexagons];
    const queue: number[] = [];
    const visited = new Set();
    unmergedHexagons.forEach((hexagon, index) => {
      if (hexagon.listings.length < mergeThreshold) {
        queue.push(index);
      }
    });

    while (queue.length > 0) {
      const currentHexagonIndex = queue.shift() as number;
      const currentHexagon = unmergedHexagons[currentHexagonIndex];
      const neighbors = spatialRelationships[currentHexagonIndex];

      // Sort neighbors based on listings count (ascending order)
      const sortedNeighbors = neighbors.sort((a, b) => {
        const countA = hexagons[a].listings.length;
        const countB = hexagons[b].listings.length;
        return countA - countB;
      });

      let mergedHexagon = currentHexagon;

      for (let neighborIndex of sortedNeighbors) {
        if (currentHexagon.listings.length >= mergeThreshold) {
          continue;
        }

        if (!visited.has(neighborIndex)) {
          const neighborHexagon = unmergedHexagons[neighborIndex];

          const poly1 = turf.polygon([currentHexagon.coordinates]);
          const poly2 = turf.polygon([neighborHexagon.coordinates]);
          const mergedPolygon = union(poly1, poly2);

          mergedHexagon = {
            coordinates: mergedPolygon?.geometry.coordinates[0],
            listings: [...mergedHexagon.listings, ...neighborHexagon.listings],
          };

          hexagons[currentHexagonIndex] = mergedHexagon;
          hexagons[neighborIndex] = { ...neighborHexagon, isMerged: true };
          visited.add(neighborIndex);

          if (mergedHexagon.listings.length >= mergeThreshold) {
            break;
          }
        }
      }
    }

    const filteredHexagons = hexagons.filter(hexagon => !hexagon.hasOwnProperty('isMerged'));
    return filteredHexagons;
  };

  const getMedianOccupancyRate = (listings: ListingVal[]) => {
    const occupancyRates = listings.map(listing => listing.occupancyRateLTM);
    const median = d3.median(occupancyRates);
    return Math.round(median);
  };

  const getNaturalBreaks = (dataArray: number[]) => {
    const numBreaks = 4;
    const jenksResult = ss.jenks(dataArray, numBreaks);
    const naturalBreaks = jenksResult.map(jenks => Math.round(jenks));
    return naturalBreaks;
  };

  const getSubmarketColor = (occupancyRate: number, occupancyRateThresholds: number[]) => {
    if (!occupancyRate) return '#00000000';
    else if (occupancyRate <= occupancyRateThresholds[0]) return NEIGHBOURHOOD_THEME[0];
    else if (occupancyRate <= occupancyRateThresholds[1]) return NEIGHBOURHOOD_THEME[1];
    else if (occupancyRate <= occupancyRateThresholds[2]) return NEIGHBOURHOOD_THEME[2];
    else if (occupancyRate <= occupancyRateThresholds[3]) return NEIGHBOURHOOD_THEME[3];
    else return NEIGHBOURHOOD_THEME[4];
  };

  let demandByBookingType: BarGraphData[] = [];
  let demandByBookingLead: BarGraphData[] = [];
  let dynamicExtraFees: BarGraphData[] = [];
  let amenityDistribution = [] as BarGraphData[];
  let cancellationPolicyDistribution = [] as PieChartData[];

  const listViewCols: GridColDef[] = [
    { field: 'listingID', headerName: 'Listing ID', width: 200, hide: true },
    {
      field: 'thumbnail_url',
      headerName: 'Listing',
      // width: 200,
      renderCell: (params: GridRenderCellParams) => {
        return (<></>
          // <Pointer
          //   data={
          //     visibleListings.data.find(
          //       (item: Listing) => item.listingID === params.row.listingID
          //     ) as Listing
          //   }
          //   canDelete={true}
          //   listings={listings.data}
          //   setListings={setListings}
          //   setSubscriptionModalOpen={setSubscriptionModalOpen}
          //   isDisabled={params.row.avgRevenue === -1}
          //   currency={currency}
          //   subscriptionModalOpen={subscriptionModalOpen}
          //   multipleBookingMarkersCallLoading={multipleBookingMarkersCallLoading}
          //   iconComponent={
          //     <Card style={{ borderRadius: 5 }}>
          //       <CardMedia component="img" height="40" image={params.value} alt="Listing Image" />
          //     </Card>
          //   }
          //   market={search.data.name}
          // />
        );
      },
    },
    {
      field: 'avgRevenue',
      headerName: 'Revenue',
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        params.value === -1 ? (
          <LockSharpIcon style={{ fontSize: 24, color: MAP_FILL_COLOR }} />
        ) : (
          <Typography>
            {exchangeRates[currency].symbol}
            {params.value != -1
              ? formatCurrency(String(convertCurrency(currency, params.value as number)))
              : 'N/A'}
          </Typography>
        ),
    },
    {
      field: 'avgOccupancyRate',
      headerName: 'Occupancy Rate (Last 12 months average)',
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        params.value === -1 ? (
          <LockSharpIcon style={{ fontSize: 24, color: MAP_FILL_COLOR }} />
        ) : (
          <Typography>{params.value != -1 ? params.value : 'N/A'}%</Typography>
        ),
    },
    {
      field: 'avgNightlyRate',
      headerName: 'Nightly Rate (Last 12 months average)',
      flex: 1,
      renderCell: (params: GridRenderCellParams) => (
        <Typography>
          {exchangeRates[currency].symbol}
          {params.value != -1
            ? formatCurrency(String(convertCurrency(currency, params.value as number)))
            : 'N/A'}
        </Typography>
      ),
    },
    {
      field: 'activeDays',
      headerName: 'Active Days (Last 12 months)',
      flex: 1,
      renderCell: (params: GridRenderCellParams) =>
        params.value === -1 ? (
          <LockSharpIcon style={{ fontSize: 24, color: MAP_FILL_COLOR }} />
        ) : (
          <Typography>{params.value != -1 ? params.value : 'N/A'}</Typography>
        ),
    },
  ];

  let listViewData: ListViewData[] = [];

  if (!visibleListings.loading) {
    const demandByBookingTypeAndLead = getDemandByBookingTypeAndLead(visibleListings.data);
    demandByBookingType = demandByBookingTypeAndLead[0];
    demandByBookingLead = demandByBookingTypeAndLead[1];
    dynamicExtraFees = getDynamicExtraFees(visibleListings.data, currency);
    listViewData = getListViewData(visibleListings.data, true);
    amenityDistribution = getAmenityDistribution(visibleListings.data);
    cancellationPolicyDistribution = getCancellationPolicyDistribution(visibleListings.data);
  }

  // console.log("demandByBookingLead",demandByBookingLead)
  //function for exporting csv data
  //freeAccessAllListings ->
  //   1. false -> export only 10K data
  //   2. true -> export all the data
  //access10kListings ->
  //   1. false -> crediduct or free 10k listing modal will open
  //   2. true -> download 10K listings

  //exporting individual listings data
  const exportIndividualListings = (freeAccessAllListings = false, access10kListings = false) => {
    if (fullExportAccess === true) {
      freeAccessAllListings = true;
    }

    if (visibleListings.data.length === 0) {
      warningAlert('No listings found to export');
      return;
    }

    let data = getListingCSVDataAsArray(visibleListings.data, currency);

    //if user dosen't have the access to >10K listings
    if (!freeAccessAllListings) {
      //here modal will open to ask for 10K listings or all listings
      //if the length of the data is more than 10K
      if (!access10kListings && data.length > 10000) {
        setExtraCreditDeductModal(true);
        return;
      }
      //slicing the array to 10K if user is not allowed to >10K listings
      data = data.slice(0, 10000);
    }

    makeDownloadableBlob(
      data,
      `${
        search.data && search.data.name ? search.data.name.replaceAll(' ', '_') : 'exported'
      }_data_${currency}`
    );
  };

  const handleDownloadCSV = (type: string) => {
    switch (type) {
      case DOWNLOAD_CSV_LISTINGS_LTM_DATA:
        exportDataHandler(true);
        return true;
      case DOWNLOAD_CSV_KEY_METRICS:
        exportDataHandler(false);
        return true;
      default:
        return false;
    }
  };

  const exportDataHandler = (exportIndivListings: boolean) => {
    if (isDisabled || blockListingExport) {
      exportSampleData(mixpanel, exportIndivListings);
      return;
    }

    let full_access: boolean = false;

    //checking if all listings of this region is subscribed or not
    user.regions.forEach((data, index) => {
      if (
        makeLowerCase(search.data.name) ===
        makeLowerCase(isObject(data) && 'region' in data ? data.region : data)
      ) {
        full_access = data.full_export_access ? data.full_export_access : false;
        setFullExportAccess(full_access);
      }
    });

    if (exportIndivListings) {
      exportIndividualListings(full_access);
    } else {
      exportMarketOverview(visibleListings, search, currency, mixpanel);
    }
  };

  const [blockListingExport, setBlockListingExport] = useState<boolean>(false);
  useEffect(() => {
    if (user && user.blockListingExport) {
      setBlockListingExport(true);
    }
  }, [user]);

  const [active, setActive] = useState<MapActiveView>({
    map: true,
    list: false,
  });

  const [revCalVals, setRevCalVals] = useState<RevenueCalculatorValues>({
    occupancy: 0,
    adr: 0,
    annualRevenue: 0,
    availability: 100,
    propertyPrice: 0,
    startupCosts: 0,
    annualExpenses: 0,
    interestRate: 1,
    annualADRIncrease: 1.5,
    annualAppreciation: 1.5,
    expenseIncrease: 1.5,
    profitTax: 0,
  });

  const [allRevCalInputsFilled, setAllRevCalInputsFilled] = useState<boolean>(false);
  useEffect(() => {
    if (
      revCalVals.annualRevenue &&
      revCalVals.annualExpenses &&
      revCalVals.propertyPrice &&
      revCalVals.startupCosts &&
      !allRevCalInputsFilled
    ) {
      mixpanel.track('allCalculatorInputsFilled');
      setAllRevCalInputsFilled(true);
    }
  }, [revCalVals]);

  useEffect(() => {
    if (isLoggedIn && !isLockedMarketInsightLoading && !isUserAllowed) {
      setTimeout(() => {
        if (user.credits > 0) {
          setShowSearchCreditDeductWarningModal(true);
        } else {
          setSubscriptionModalOpen(true);
        }
      }, 5020);
    }
  }, [isUserAllowed, isLoggedIn, isLockedMarketInsightLoading]);

  //to make tooltip responsive both desktop and mobile
  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const [demoMarketWarning, setDemoMarketWarning] = useState<boolean>(true);
  const [filterAlertOpen, setFilterAlertOpen] = useState<boolean>(true);

  const [openTop10ManagerModal, setOpenTop10ManagerModal] = useState<boolean>(false);

  useEffect(() => {
    if (
      sample &&
      search.data.name.toLowerCase() === sampleMarket &&
      dashboardState.showInsightsDashboard &&
      demoMarketWarning &&
      !visibleListings.loading &&
      !isHighlight &&
      !showAppTour
    ) {
      setDemoMarketWarning(false);
      infoAlert(
        'You are viewing a demo market to explore the analytics and features available with purchase. Find your market in the search box above.'
      );
    }
  }, [sample, dashboardState, visibleListings, isHighlight]);

  useEffect(() => {
    if (
      dashboardState.showInsightsDashboard &&
      !filterApplied &&
      isUserAllowed &&
      filterAlertOpen &&
      !visibleListings.loading &&
      !isHighlight
    ) {
      setFilterAlertOpen(false);
      warningAlert(
        "Filter isn't configured! Make sure you set up your filter to get an accurate market view."
      );
    }
  }, [filterApplied, isUserAllowed, visibleListings, dashboardState, isHighlight]);

  useEffect(() => {
    if (
      !listings.loading &&
      listings.data &&
      Object.keys(listings.data).length > 0 &&
      visibleListings.data &&
      visibleListings.data.length < 1
    ) {
      warningAlert("There isn't any listing matching your criteria.");
    }
  }, [noSample]);

  //function to be used when the credit should deducted for exporting >10k data
  const [creditsToBeDeducted, setCreditsToBeDeducted] = useState<number>(1);
  useEffect(() => {
    if (!listings.loading && Object.keys(listings.data).length > 10000) {
      setCreditsToBeDeducted(Math.ceil(Object.keys(listings.data).length / 10000));
    }
  }, [listings]);

  // historical data
  const hasSetHistoricalDataBeenCalled = useRef(false);
  useEffect(() => {
    if (!isUserAllowed && hasSetHistoricalDataBeenCalled.current) {
      return;
    }

    if (!isUserAllowed) {
      (async () => {
        const demoData = await fetchDemoHistoryFromS3();
        dispatch(setHistoricalData(demoData['message']['monthly_past_pricings']));
      })();
      hasSetHistoricalDataBeenCalled.current = true;
    }

    if (isUserAllowed && visibleListings.data && visibleListings.data.length > 0) {
      const historicalData = getHistoricalMarketPerformance(visibleListings.data);
      dispatch(setHistoricalData(historicalData));
    }
  }, [visibleListings, isUserAllowed]);

  if (
    (pathname === '/airbnb-data' || pathname === '/airbnb-data/') &&
    redirectSearchPageQuery !== 'true'
  ) {
    const redirectTo = '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove';
    window.history.pushState({}, '', redirectTo);
    dispatch(getDistrictInfo('the city of brighton and hove', '0', 'united-kingdom'));
    // window.location.href =
    //           '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove';
    // return (
    //   <>
    //     {!isUserVerified && rateLimitAlert && (
    //       <ViewDemoButton
    //         handleClick={() => setIsEmailVerifyModalOpen(true)}
    //         buttonText="You have used up all 3 free searches. Please verify your email to get free searches."
    //         topOffsetMobile="3%"
    //       />
    //     )}

    //     <IndividualOnBoardingPage
    //       SearchBox={OnBoardingSearchBox}
    //       onSamplePageClick={() => {
    //         window.location.href =
    //           '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove';
    //       }}
    //       onVideoClick={() => {
    //         window.open('https://youtu.be/l46RvDRRF1E', '_blank');
    //       }}
    //       cover={investmentLandingPage}
    //     />
    //   </>
    // );
  }

  const deductCredits = async () => {
    setExtraExportCreditsLoading(true);

    //user don't have enough credits so let them see the subscription modal
    if (user.credits === 0 || user.credits < creditsToBeDeducted - 1) {
      setSubscriptionModalOpen(true);
      setExtraExportCreditsLoading(false);
      return;
    }

    const url = 'https://w1ec9zcvbk.execute-api.us-east-2.amazonaws.com/default/getUserInfo';
    const { message } = await callApi(
      url,
      {
        queryParams: {
          creditsToBeDeducted: creditsToBeDeducted - 1,
          market: makeLowerCase(search.data.name),
        },
      },
      true
    );

    //if they don't have enough credits then show them not enough credits error
    if (message === 'Not enough credits') {
      setExtraExportError(true);
      return;
    }

    setFullExportAccess(true);
    setExtraExportCreditsLoading(false);
    exportIndividualListings(true); //passing true as we want to get the whole data now.
  };

  const handleConfirmSaveCountryPlanMarket = async () => {
    const URL =
      'https://sd9mpt9sy7.execute-api.us-east-2.amazonaws.com/default/addMarketInCountryPlanUser';
    const res = await callApi(
      URL,
      {
        queryParams: {
          name: search.data.name,
          city: search.data.city,
          countryCode: search.data.countryCode,
        },
      },
      true
    );
    return res;
  };

  const handleSaveCountryPlanMarketApiResponse = (res: any) => {
    if (res.message?.error) {
      infoAlert(res.message?.error?.toString());
      return;
    }
    successAlert('Market is saved successfully!');
    setConfirmSaveCountryPlanMarketModalOpen(undefined);
    return;
  };

  const ExportButtonOptionTooltip = ({ body, children }) => {
    return (
      <InfoTooltip
        title={
          <Card>
            <CardContent style={{ background: COLOR_TOOLTIP_BACKGROUND }}>
              <Grid container direction="column" alignItems="flex-start">
                {body}
              </Grid>
            </CardContent>
          </Card>
        }
      >
        {children}
      </InfoTooltip>
    );
  };

  const DownloadCSVButton = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
        <OutlinedRectangularButton
          height="40px"
          width="160px"
          colors={{
            backgroundColor: COLOR_PRIMARY_DARK,
            color: '#fff',
            borderColor: COLOR_PRIMARY_DARK,
          }}
          icon={<KeyboardArrowDownRoundedIcon sx={{ fontSize: '25px' }} />}
          text="EXPORT"
          handleOnClick={() => setIsDownloadOptionOpen(true)}
        />

        {isDownloadOptionOpen && (
          <Select
            displayEmpty={true}
            onChange={event => {
              handleDownloadCSV(event.target.value as string);
            }}
            sx={{
              opacity: 0,
              height: 0,
              width: 0,
            }}
            open={isDownloadOptionOpen}
            onClose={() => {
              setIsDownloadOptionOpen(false);
            }}
          >
            <MenuItem value={DOWNLOAD_CSV_LISTINGS_LTM_DATA}>
              <ExportButtonOptionTooltip
                body={
                  <Typography variant="body2" style={{ fontWeight: 400 }}>
                    Download the LTM historical performance data of the individual Airbnb listings
                    visible on the map.
                    <br />
                    <br />
                    <span style={{ fontWeight: 'bold' }}>
                      If the market is locked, you will get a sample CSV.
                    </span>
                  </Typography>
                }
              >
                <Box
                  sx={{
                    width: '280px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  {DOWNLOAD_CSV_LISTINGS_LTM_DATA}
                  <DownloadIcon style={{ color: COLOR_PRIMARY_DARK }} />
                </Box>
              </ExportButtonOptionTooltip>
            </MenuItem>
            <Divider />
            <MenuItem value={DOWNLOAD_CSV_KEY_METRICS}>
              <ExportButtonOptionTooltip
                body={
                  <Typography variant="body2" style={{ fontWeight: 400 }}>
                    Download the Market Overview CSV to compare overall market statistics like
                    occupancy rate, ADR, revenue, between different property sizes.
                    <br />
                    <br />
                    <span style={{ fontWeight: 'bold' }}>
                      If the market is locked, you will get a sample CSV.
                    </span>
                  </Typography>
                }
              >
                <Box
                  sx={{
                    width: '280px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 'bold',
                  }}
                >
                  {DOWNLOAD_CSV_KEY_METRICS}
                  <DownloadIcon style={{ color: COLOR_PRIMARY_DARK }} />
                </Box>
              </ExportButtonOptionTooltip>
            </MenuItem>
          </Select>
        )}
      </div>
    );
  };

  // const isFullScreenLoadingOn = (listings.loading ||
  //   otaListings.loading ||
  //   isLockedMarketInsightLoading) as boolean;
  const isFullScreenLoadingOn = (listings.loading || isLockedMarketInsightLoading) as boolean;

  if (redirectSearchPageQuery === 'true') {
    return (
      <IndividualOnBoardingPage
        SearchBox={OnBoardingSearchBox}
        onSamplePageClick={() => {
          window.location.href =
            '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove';
        }}
        onVideoClick={() => {
          window.open('https://youtu.be/l46RvDRRF1E', '_blank');
        }}
        cover={investmentLandingPage}
      />
    );
  }

  return (
    <>
      <Backdrop
        open={isFullScreenLoadingOn}
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.appBar - 1 }}
      >
        <FullScreenAnimationLoader />
      </Backdrop>

      <Grid
        container
        direction="column"
        spacing={2}
        style={{ position: 'relative', top: 0, left: 0 }}
      >
        {/* Universal view*/}

        {/* {isBlackFridayAlertOn && (
          <BlackFridayAlert
            isSubscribed={user.isSubscribed}
            setClose={setIsBlackFridayAlertOn}
            infoAlert={infoAlert}
          />
        )} */}

        {!isUserVerified && rateLimitAlert && (
          <ViewDemoButton
            handleClick={() => setIsEmailVerifyModalOpen(true)}
            buttonText="You have used up all 3 free searches. Please verify your email to get free searches."
            topOffsetMobile="3%"
          />
        )}

        {!isEmailVerifyModalOpen && (
          <ToastContainer position="bottom-left" newestOnTop style={{ marginTop: '40px' }} />
        )}

        {isUserAllowed &&
          search.data &&
          search.data.name !== sampleMarket &&
          confirmSaveCountryPlanMarketModalOpen !== undefined &&
          checkUserCountryAccessStatusWithMarket(user, search.data) === 'not-subscribed' && (
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              item
            >
              <div style={{ maxWidth: '300px', marginTop: '10px', marginBottom: '10px' }}>
                <UnlockCTAButton
                  handleClick={() => {
                    setConfirmSaveCountryPlanMarketModalOpen(true);
                  }}
                  text={'Save this market'}
                  invert={true}
                />
              </div>
            </Grid>
          )}

        {!isUserAllowed && (
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            item
            // className="insightsTopPadding"
          >
            <Grid item>
              <Collapse in={openAlert}>
                <Grid container style={{ width: '100%', gap: '80px' }}>
                  <Grid item>
                    <UnlockCTAButton
                      handleClick={() => {
                        if (user.credits > 0) {
                          setShowSearchCreditDeductWarningModal(true);
                        } else {
                          setSubscriptionModalOpen(true);
                        }
                      }}
                      text={'Get Access To All The Data'}
                    />
                  </Grid>
                  <Grid item>
                    <UnlockCTAButton
                      handleClick={() =>
                        window.open(
                          '/airbnb-data/united-kingdom/0/the%20city%20of%20brighton%20and%20hove',
                          '_self'
                        )
                      }
                      text={'View Demo Market'}
                      invert={true}
                    />
                  </Grid>
                </Grid>
              </Collapse>
            </Grid>
          </Grid>
        )}

        <Grid container direction="row" spacing={2} item style={{ position: 'relative' }}>
          {dynamicTrigger && !multipleMarkersCallLoading && (
            <div
              style={{
                height: '97%',
                position: 'absolute',
                top: '0',
                left: '8px',
                width: '100%',
                background: `${COLOR_TEXT_3}77`,
                zIndex: dynamicDataAnimationZindex,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <DynamicDataCardLoading />
            </div>
          )}

          {
            <div
              style={{
                height: '97%',
                position: 'absolute',
                top: '0',
                left: '8px',
                width: '100%',
                zIndex: -1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              id="kpiCards"
            ></div>
          }
          <Grid item xs={4}>
            {visibleListings.loading ? (
              <LoadingCard color={COLOR_PRIMARY_LIGHT} height={150} />
            ) : (<></>
              // <KeyMetricsCard
              //   title={isDisabled ? 'Previous Month Revenue' : 'Revenue'}
              //   listings={visibleListings.data}
              //   color={COLOR_PRIMARY_LIGHT}
              //   tooltip={
              //     isDisabled
              //       ? {
              //           title: 'Previous Month Revenue',
              //           content: [
              //             `The previous month’s revenue of listings on the map.`,
              //             `Revenue = ((Median Nightly Rate + Extra Guest Fees) x (Median Occupancy Rate x Number of available days in the month)) + (Cleaning Fees x Number of bookings in the month)`,
              //             `Only months having data points are taken into consideration while calculating LTM Occupancy Rate.`,
              //           ],
              //         }
              //       : {
              //           title: 'Revenue',
              //           content: [
              //             `The median monthly revenue (nightly rate + cleaning fees + extra  guest fees) earned over the past 12 months.`,
              //             `This Revenue figure represents the median over the past 12 months and does not include taxes, service fees, or additional guest fees.`,
              //           ],
              //         }
              //   }
              //   isDisabled={isDisabled}
              //   multipleMarkersCallLoading={multipleMarkersCallLoading}
              //   currency={currency}
              //   handleOnSampleClick={handleOnSampleClick}
              //   lastMonthData="process"
              //   historicalDataLink={
              //     search.data.name !== ''
              //       ? `/historical/${search.data.countryCode ? search.data.countryCode : 0}/${
              //           search.data.city ? search.data.city : 0
              //         }/${search.data.name}`
              //       : 'None'
              //   }
              //   renderIn="insights"
              //   isUserAllowed={isUserAllowed}
              //   svgLTMGraph={lockedMarketSvgGraph ? lockedMarketSvgGraph.revenueSvgGraph : null}
              //   lockedMarketSvgGraphLoadingStatus={lockedMarketSvgGraphLoadingStatus}
              //   defaultSvgLtmGraphFallbackImage={graphSvgDefaultRevenueImg}
              // />
            )}
          </Grid>

          <Grid item xs={4}>
            {visibleListings.loading ? (
              <LoadingCard color={COLOR_ACCENT_1} height={150} />
            ) : (<></>
              // <KeyMetricsCard
              //   title={isDisabled ? 'Previous Month Occupancy Rate' : 'Occupancy Rate'}
              //   listings={visibleListings.data}
              //   color={COLOR_ACCENT_1}
              //   tooltip={
              //     isDisabled
              //       ? {
              //           title: 'Previous Month Occupancy Rate',
              //           content: [
              //             `The previous month’s average occupancy rate of listings on the map.`,
              //             `Occupancy Rate = Number of booked days in the month / Number of available days in the month`,
              //             `Only months having data points are taken into consideration while calculating average.`,
              //           ],
              //         }
              //       : {
              //           title: 'Occupancy Rate',
              //           content: [
              //             `The number of booked days divided by the total number of days available for rent over the past 12 months. Properties with no reservations are excluded.`,
              //             `This Occupancy Rate figure represents the median over the past 12 months.`,
              //           ],
              //         }
              //   }
              //   isDisabled={isDisabled}
              //   multipleMarkersCallLoading={multipleMarkersCallLoading}
              //   currency={currency}
              //   handleOnSampleClick={handleOnSampleClick}
              //   lastMonthData="process"
              //   historicalDataLink={
              //     search.data.name !== ''
              //       ? `/historical/${search.data.countryCode ? search.data.countryCode : 0}/${
              //           search.data.city ? search.data.city : 0
              //         }/${search.data.name}`
              //       : 'None'
              //   }
              //   renderIn="insights"
              //   isUserAllowed={isUserAllowed}
              //   svgLTMGraph={
              //     lockedMarketSvgGraph ? lockedMarketSvgGraph.occupancyRateSvgGraph : null
              //   }
              //   lockedMarketSvgGraphLoadingStatus={lockedMarketSvgGraphLoadingStatus}
              //   defaultSvgLtmGraphFallbackImage={graphSvgDefaultORImg}
              // />
            )}
          </Grid>

          <Grid item xs={4}>
            {visibleListings.loading ? (
              <LoadingCard color={COLOR_ACCENT_2} height={150} />
            ) : (<></>
              // <KeyMetricsCard
              //   title="Nightly Rate"
              //   listings={visibleListings.data}
              //   color={COLOR_ACCENT_2}
              //   tooltip={{
              //     title: 'Nightly Rate',
              //     content: [
              //       `Nightly Rate is the average booked nightly rate for all booked days over the past 12 months.`,
              //     ],
              //   }}
              //   isDisabled={false}
              //   multipleMarkersCallLoading={multipleMarkersCallLoading}
              //   currency={currency}
              //   handleOnSampleClick={handleOnSampleClick}
              //   historicalDataLink={
              //     search.data.name !== ''
              //       ? `/historical/${search.data.countryCode ? search.data.countryCode : 0}/${
              //           search.data.city ? search.data.city : 0
              //         }/${search.data.name}`
              //       : 'None'
              //   }
              //   renderIn="insights"
              //   isUserAllowed={isUserAllowed}
              //   svgLTMGraph={lockedMarketSvgGraph ? lockedMarketSvgGraph.adrSvgGraph : null}
              //   lockedMarketSvgGraphLoadingStatus={lockedMarketSvgGraphLoadingStatus}
              //   defaultSvgLtmGraphFallbackImage={graphSvgDefaultADRImg}
              // />
            )}
          </Grid>

          {/* Mobile view */}

          {matches && (
            <Grid item xs={12}>
              <Card>
                <CardContent>
                  <div className={classes.mapTopRightToolbarContainer}>
                    <CustomSwitch
                      active={active}
                      setActive={setActive}
                      tooltipContains={
                        <Typography variant="body2" style={{ fontWeight: 500 }}>
                          The map only shows 500 listings at a time. If you don't see your listing,
                          try zooming in.
                          <br />
                          <br />
                          • If a listing was listed on Airbnb in the last 4 months, it might not be
                          showing on the map.
                          <br />
                          <br />
                          • If a listing did not receive any bookings in the past 6 months, the
                          listing won't be showing on the map.
                          <br />
                        </Typography>
                      }
                    />

                    {!search.loading && active.map && (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <MapPointerRevRangeColorCard
                          revPotentialRangeInvestment={revPotentialRangeInvestment}
                          isDisabled={isDisabled}
                          currency={currency}
                          setIndividualRevenuePotentialRange={setIndividualRevenuePotentialRange}
                        />
                      </div>
                    )}

                    <Button
                      id="filterButton"
                      className={clsx(classes.customButtonActive, {
                        [classes.customButtonActive]:
                          dashboardState.showInsightsDashboard && filterApplied,
                        [classes.customButton]:
                          dashboardState.showInsightsDashboard && !filterApplied,
                      })}
                      aria-label="open drawer"
                      onClick={toggleDrawer}
                    >
                      <FilterListIcon />
                      Filters
                    </Button>
                  </div>
                  <div>{dynamicTrigger && <Typography>Fetching data...</Typography>}</div>

                  <Paper id="map" className={classes.mapContainer}>
                    {!search.loading && active.map && (
                      <>
                        {visibleListings.data && visibleOTAListings.data && (
                          <MapListingCountInfoBox
                            listingsLength={visibleListings.data.length}
                            otaListingsLength={visibleOTAListings.data.length}
                            mapAirbnbMarkersCount={mapAirbnbMarkersCount}
                            mapOTAMarkersCount={mapOTAMarkersCount}
                            isClusterVisible={
                              visibleListings.data.length <= 50 ||
                              zoom > CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD
                            }
                            isMapChanging={dynamicTrigger}
                          />
                        )}
                        {multipleMarkersCallLoading && (
                          <LinearProgress
                            sx={{
                              height: '6px',
                              background: `${COLOR_SECONDARY_1}55 !important`,
                              '& .MuiLinearProgress-bar': {
                                background: COLOR_SECONDARY_1,
                              },
                            }}
                          />
                        )}
                        <GoogleMapReact
                          bootstrapURLKeys={{
                            key: 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk',
                            libraries: ['drawing', 'places', 'visualization'],
                            id: 'dashboard',
                          }}
                          center={mapCenter}
                          options={mapOptions}
                          zoom={zoom}
                          resetBoundsOnResize
                          onChange={handleMapChange}
                          yesIWantToUseGoogleMapApiInternals
                          onGoogleApiLoaded={({ map, maps }) =>
                            apiIsLoaded(map, maps, search.data.polygon, search.data.multiPolygon)
                          }
                        >
                          {!visibleOTAListings.loading &&
                            (visibleOTAListings.data?.length <= 50 ||
                              zoom > CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD) &&
                            otaMarkers}
                          {!visibleListings.loading &&
                          (visibleListings.data.length <= 50 ||
                            zoom > CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD) &&
                          clusterMarkers
                            ? markers
                            : clusterMarkers}
                          {!isTailoredRegionAnimationShown && tailoredRegionRedirectionMarkers}
                        </GoogleMapReact>
                      </>
                    )}

                    {!search.loading && active.list && (
                      <div style={{ height: '100%' }}>
                        <DataGrid
                          sortingOrder={['desc']}
                          className={classes.tableRoot}
                          rows={listViewData}
                          columns={listViewCols}
                          disableColumnFilter={true}
                          disableColumnMenu={true}
                          initialState={{
                            sorting: {
                              sortModel: [{ field: 'avgRevenue', sort: 'desc' }],
                            },
                          }}
                        />
                      </div>
                    )}
                  </Paper>
                  {(isUserAllowed && multipleMarkersCallLoading) || listings.loading ? (
                    <CircularProgress style={{ marginBottom: 10, marginTop: -5 }} />
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <DownloadCSVButton />
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
          )}
          {matches &&
            (overviewDashboardMode.showInvesting || overviewDashboardMode.showRentalArbitrage) && (
              <Grid container direction="column" item spacing={2}>
                <Grid item>
                  {listings.loading || visibleListings.loading || visibleOTAListings.loading ? (
                    <LoadingCard height={150} />
                  ) : (
                    <SupplyCard
                      listings={visibleListings}
                      otaListings={visibleOTAListings}
                      handleOnSampleClick={handleOnSampleClick}
                      isDisabled={isDisabled}
                      setOpenTop10ManagerModal={setOpenTop10ManagerModal}
                      filterVal={filterVal}
                      currency={currency}
                    />
                  )}
                </Grid>

                {/* <Grid container item xs={12} style={{ flexBasis: 0 }}>
                  {!isDisabled && demandByBookingLead.length === 0 ? (
                    <LoadingCard height={150} />
                  ) : (
                    <BarDataCard
                      title="Booking Type"
                      tooltipContent={
                        <>
                          <span style={{ fontWeight: 'bold' }}>Single Night:</span> 1 night
                          <br />
                          <span style={{ fontWeight: 'bold' }}>Multiple Night:</span> 2-6 nights
                          <br />
                          <span style={{ fontWeight: 'bold' }}>Weekly:</span> 7-15 nights
                          <br />
                          <span style={{ fontWeight: 'bold' }}>Mid-Term:</span> 15+ nights
                        </>
                      }
                      data={isDisabled ? dummyBookingTypeBarGraphData : demandByBookingType}
                      orientation="vertical"
                      unit="%"
                      label="%"
                      graphHeight={200}
                      barColor={COLOR_PRIMARY_1_600}
                      barAccentColor={COLOR_PRIMARY_1}
                      isDisabled={isDisabled}
                      handleOnSampleClick={handleOnSampleClick}
                      graphPreviewDefaultTitle={'Multiple Night Stays'}
                      previewTextObj={getPreviewTextObj(
                        'supply',
                        'bookingType',
                        filterVal,
                        visibleListings.data
                      )}
                    />
                  )}
                </Grid>

                <Grid container item xs={12} style={{ flexBasis: 0 }}>
                  {!isDisabled && demandByBookingLead.length === 0 ? (
                    <LoadingCard height={150} />
                  ) : (
                    <BarDataCard
                      title="Booking Lead Type"
                      tooltipContent={
                        <>
                          <span style={{ fontWeight: 'bold' }}>Last-Minute:</span> Booked less than
                          7 days ahead
                          <br />
                          <span style={{ fontWeight: 'bold' }}>Standard:</span> Booked 7-30 days
                          ahead
                          <br />
                          <span style={{ fontWeight: 'bold' }}>Advance:</span> Booked 30+ days ahead
                        </>
                      }
                      data={isDisabled ? dummyBookingLeadBarGraphData : demandByBookingLead}
                      orientation="vertical"
                      unit="%"
                      label="%"
                      graphHeight={200}
                      barColor={COLOR_PRIMARY_1_600}
                      barAccentColor={COLOR_PRIMARY_1}
                      isDisabled={isDisabled}
                      handleOnSampleClick={handleOnSampleClick}
                      graphPreviewDefaultTitle={'Last-Minute'}
                      previewTextObj={getPreviewTextObj(
                        'supply',
                        'bookingLead',
                        filterVal,
                        visibleListings.data
                      )}
                    />
                  )}
                </Grid>

                <Grid item>
                  {!isDisabled && demandByBookingLead.length === 0 ? (
                    <LoadingCard height={150} />
                  ) : (
                    <DemandCard
                      listings={visibleListings}
                      otaListings={visibleOTAListings}
                      handleOnSampleClick={handleOnSampleClick}
                      isDisabled={isDisabled}
                      filterVal={filterVal}
                    />
                  )}
                </Grid> */}

                <Grid item>
                  {listings.loading || visibleListings.loading ? (
                    <LoadingCard height={150} />
                  ) : (
                    <BarDataCard
                      title="Amenity"
                      tooltipContent="The horizontal bars show the percentage of listings in your current map view that have that specific amenity or cservice."
                      data={amenityDistribution}
                      orientation="vertical"
                      unit="%"
                      label="%"
                      graphHeight={450}
                      barColor={COLOR_SECONDARY_1_300}
                      barAccentColor={COLOR_SECONDARY_1_600}
                    />
                  )}
                </Grid>

                <Grid item>
                  {listings.loading || visibleListings.loading ? (
                    <LoadingCard height={150} />
                  ) : (
                    <PieDataCard
                      title="Cancellation Policy"
                      tooltipContent="Market cancellation policies"
                      data={cancellationPolicyDistribution}
                      unit="%"
                      pieColors={[COLOR_TERTIARY_1_400, COLOR_TERTIARY_1_300, COLOR_TERTIARY_1_200]}
                      pieAccentColor={COLOR_TERTIARY_1_500}
                    />
                  )}
                </Grid>
              </Grid>
            )}

          {matches && (
            <Grid item xs={12}>
              {listings.loading || visibleListings.loading ? (
                <LoadingCard height={150} />
              ) : (
                <BarDataCard
                  title="Extra Pricing"
                  tooltipContent={'Other fees counted as income'}
                  data={dynamicExtraFees}
                  orientation="vertical"
                  unit={currency}
                  label={exchangeRates[currency].symbol}
                  graphHeight={150}
                  barColor={COLOR_SECONDARY_2_600}
                  barAccentColor={COLOR_SECONDARY_2}
                />
              )}
            </Grid>
          )}
        </Grid>

        {/* Laptop & Tablet view */}

        {!matches && (
          <Grid container direction="row" justifyContent="space-between" item>
            <Grid
              container
              direction="column"
              spacing={2}
              item
              xs={12}
              md={6}
              lg={4}
              style={{
                height: '710px',
                overflowY: 'scroll',
                overflowX: 'hidden',
                position: 'relative',
              }}
              className="innerDivScrollBar"
            >
              {dynamicTrigger && !multipleMarkersCallLoading && (
                <div
                  style={{
                    height: '100%',
                    position: 'sticky',
                    top: '2px',
                    left: '0',
                    width: '100%',
                    background: `${COLOR_TEXT_3}77`,
                    zIndex: dynamicDataAnimationZindex,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <DynamicDataCardLoading />
                </div>
              )}

              {(overviewDashboardMode.showInvesting ||
                overviewDashboardMode.showRentalArbitrage) && (
                <Grid
                  container
                  direction="column"
                  item
                  spacing={2}
                  style={{ zIndex: dynamicDataZindex }}
                >
                  <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {listings.loading || visibleListings.loading || visibleOTAListings.loading ? (
                      <LoadingCard height={150} />
                    ) : (
                      <SupplyCard
                        listings={visibleListings}
                        otaListings={visibleOTAListings}
                        handleOnSampleClick={handleOnSampleClick}
                        isDisabled={isDisabled}
                        setOpenTop10ManagerModal={setOpenTop10ManagerModal}
                        filterVal={filterVal}
                        currency={currency}
                      />
                    )}
                  </Grid>

                  {/* <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {!isDisabled && demandByBookingLead.length === 0 ? (
                      <LoadingCard height={150} />
                    ) : (
                      <BarDataCard
                        title="Booking Type"
                        tooltipContent={
                          <>
                            <span style={{ fontWeight: 'bold' }}>Single Night:</span> 1 night
                            <br />
                            <span style={{ fontWeight: 'bold' }}>Multiple Night:</span> 2-6 nights
                            <br />
                            <span style={{ fontWeight: 'bold' }}>Weekly:</span> 7-15 nights
                            <br />
                            <span style={{ fontWeight: 'bold' }}>Mid-Term:</span> 15+ nights
                          </>
                        }
                        data={isDisabled ? dummyBookingTypeBarGraphData : demandByBookingType}
                        orientation="vertical"
                        unit="%"
                        label="%"
                        graphHeight={200}
                        barColor={COLOR_PRIMARY_1_600}
                        barAccentColor={COLOR_PRIMARY_1}
                        isDisabled={isDisabled}
                        handleOnSampleClick={handleOnSampleClick}
                        graphPreviewDefaultTitle={'Multiple Night Stays'}
                        previewTextObj={getPreviewTextObj(
                          'supply',
                          'bookingType',
                          filterVal,
                          visibleListings.data
                        )}
                      />
                    )}
                  </Grid>

                  <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {!isDisabled && demandByBookingLead.length === 0 ? (
                      <LoadingCard height={150} />
                    ) : (
                      <BarDataCard
                        title="Booking Lead Type"
                        tooltipContent={
                          <>
                            <span style={{ fontWeight: 'bold' }}>Last-Minute:</span> Booked less
                            than 7 days ahead
                            <br />
                            <span style={{ fontWeight: 'bold' }}>Standard:</span> Booked 7-30 days
                            ahead
                            <br />
                            <span style={{ fontWeight: 'bold' }}>Advance:</span> Booked 30+ days
                            ahead
                          </>
                        }
                        data={isDisabled ? dummyBookingLeadBarGraphData : demandByBookingLead}
                        orientation="vertical"
                        unit="%"
                        label="%"
                        graphHeight={200}
                        barColor={COLOR_PRIMARY_1_600}
                        barAccentColor={COLOR_PRIMARY_1}
                        isDisabled={isDisabled}
                        handleOnSampleClick={handleOnSampleClick}
                        graphPreviewDefaultTitle={'Last-Minute'}
                        previewTextObj={getPreviewTextObj(
                          'supply',
                          'bookingLead',
                          filterVal,
                          visibleListings.data
                        )}
                      />
                    )}
                  </Grid> */}

                  {/* <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {!isDisabled && demandByBookingLead.length === 0 ? (
                      <LoadingCard height={150} />
                    ) : (
                      <DemandCard
                        listings={visibleListings}
                        otaListings={visibleOTAListings}
                        handleOnSampleClick={handleOnSampleClick}
                        isDisabled={isDisabled}
                        filterVal={filterVal}
                      />
                    )}
                  </Grid> */}

                  <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {listings.loading || visibleListings.loading ? (
                      <LoadingCard height={150} />
                    ) : (
                      <BarDataCard
                        title="Amenity"
                        tooltipContent="The horizontal bars show the percentage of listings in your current map view that have that specific amenity or service."
                        data={amenityDistribution}
                        orientation="vertical"
                        unit="%"
                        label="%"
                        graphHeight={450}
                        barColor={COLOR_SECONDARY_1_300}
                        barAccentColor={COLOR_SECONDARY_1_600}
                      />
                    )}
                  </Grid>

                  <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {listings.loading || visibleListings.loading ? (
                      <LoadingCard height={150} />
                    ) : (
                      <Grid item xs={12}>
                        <PieDataCard
                          title="Cancellation Policy"
                          tooltipContent="Market cancellation policies"
                          data={cancellationPolicyDistribution}
                          unit="%"
                          pieColors={[
                            COLOR_TERTIARY_1_400,
                            COLOR_TERTIARY_1_300,
                            COLOR_TERTIARY_1_200,
                          ]}
                          pieAccentColor={COLOR_TERTIARY_1_500}
                        />
                      </Grid>
                    )}
                  </Grid>

                  <Grid container item xs={12} style={{ flexBasis: 0 }}>
                    {listings.loading || visibleListings.loading ? (
                      <LoadingCard height={150} />
                    ) : (
                      <BarDataCard
                        title="Extra Pricing"
                        tooltipContent={'Other fees counted as income'}
                        data={dynamicExtraFees}
                        orientation="vertical"
                        unit={currency}
                        label={exchangeRates[currency].symbol}
                        graphHeight={150}
                        barColor={COLOR_SECONDARY_2_600}
                        barAccentColor={COLOR_SECONDARY_2}
                      />
                    )}
                  </Grid>
                </Grid>
              )}
            </Grid>

            <Grid container item xs={12} md={6} lg={8}>
              <Card style={{ width: '100%' }}>
                <CardContent>
                  <div className={classes.mapCardContainer}>
                    <div className={classes.mapTopRightToolbarContainer}>
                      <CustomSwitch
                        active={active}
                        setActive={setActive}
                        tooltipContains={
                          <Typography variant="body2" style={{ fontWeight: 500 }}>
                            The map only shows 500 listings at a time. If you don't see your
                            listing, try zooming in.
                            <br />
                            <br />
                            • If a listing was listed on Airbnb in the last 4 months, it might not
                            be showing on the map.
                            <br />
                            <br />
                            • If a listing did not receive any bookings in the past 6 months, the
                            listing won't be showing on the map.
                            <br />
                          </Typography>
                        }
                      />

                      {!search.loading && active.map && mapMode == 'Listings' && (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <MapPointerRevRangeColorCard
                            revPotentialRangeInvestment={revPotentialRangeInvestment}
                            isDisabled={isDisabled}
                            currency={currency}
                            setIndividualRevenuePotentialRange={setIndividualRevenuePotentialRange}
                          />
                        </div>
                      )}

                      <Button
                        id="filterButton"
                        className={clsx(classes.customButtonActive, {
                          [classes.customButtonActive]:
                            dashboardState.showInsightsDashboard && filterApplied,
                          [classes.customButton]:
                            dashboardState.showInsightsDashboard && !filterApplied,
                        })}
                        aria-label="open drawer"
                        onClick={toggleDrawer}
                      >
                        <FilterListIcon />
                        Filters
                      </Button>
                    </div>
                  </div>
                  <div>{dynamicTrigger && <Typography>Fetching data...</Typography>}</div>

                  <Paper
                    id="map"
                    className={classes.mapContainer}
                    onMouseLeave={() => {
                      setHoveredNeighbourhoodPosX(null);
                      setHoveredNeighbourhoodPosY(null);
                      setHoveredNeighbourhood(null);
                    }}
                  >
                    {!search.loading && active.map && (
                      <>
                        {mapMode == 'Listings' &&
                          visibleListings.data &&
                          visibleOTAListings.data && (
                            <MapListingCountInfoBox
                              listingsLength={visibleListings.data.length}
                              otaListingsLength={visibleOTAListings.data.length}
                              mapAirbnbMarkersCount={mapAirbnbMarkersCount}
                              mapOTAMarkersCount={mapOTAMarkersCount}
                              isClusterVisible={
                                visibleListings.data.length <= 50 ||
                                zoom > CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD
                              }
                              isMapChanging={dynamicTrigger}
                            />
                          )}
                        {multipleMarkersCallLoading && (
                          <LinearProgress
                            sx={{
                              height: '6px',
                              background: `${COLOR_SECONDARY_1}55 !important`,
                              '& .MuiLinearProgress-bar': {
                                background: COLOR_SECONDARY_1,
                              },
                            }}
                          />
                        )}
                        {!multipleMarkersCallLoading &&
                          listings.data &&
                          mapCopy &&
                          mapsCopy &&
                          !search.loading &&
                          (search.data.polygon || search.data.multiPolygon) && (
                            <ToggleSwitch
                              values={['Listings', 'Neighbourhood Analysis']}
                              type={mapMode}
                              setType={setMapMode}
                              float="left"
                              size="large"
                              customStyle={{
                                zIndex: 3,
                                position: 'absolute',
                                top: '7px',
                                left: '7px',
                              }}
                            />
                          )}
                        {mapMode == 'Neighbourhood Analysis' && (
                          <div
                            style={{
                              width: '100px',
                              padding: '15px',
                              background: 'white',
                              boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
                              borderRadius: 2,
                              zIndex: 3,
                              position: 'absolute',
                              bottom: '20px',
                              right: '7px',
                            }}
                          >
                            <Typography variant="body2">Neighbourhood Occupancies</Typography>
                            {Object.keys(neighbourhoodChoroplethLegends)
                              .reverse()
                              .map(breakpoint => (
                                <Grid container direction="row" style={{ marginTop: '10px' }}>
                                  <div
                                    style={{
                                      width: '20px',
                                      height: '20px',
                                      background: neighbourhoodChoroplethLegends[breakpoint],
                                      borderRadius: '10%',
                                      border: '1px rgba(110.06, 110.06, 110.06, 0.32) solid',
                                      marginRight: '10px',
                                    }}
                                  />
                                  <Typography variant="body2">{breakpoint}</Typography>
                                </Grid>
                              ))}
                          </div>
                        )}
                        <GoogleMapReact
                          bootstrapURLKeys={{
                            key: 'AIzaSyDUnmEGqix9gziZQjtCQFJ7mCTSDV9yPDk',
                            libraries: ['drawing', 'places', 'visualization'],
                            id: 'dashboard',
                          }}
                          center={mapCenter}
                          options={mapOptions}
                          zoom={zoom}
                          resetBoundsOnResize
                          onChange={handleMapChange}
                          yesIWantToUseGoogleMapApiInternals
                          onGoogleApiLoaded={({ map, maps }) =>
                            apiIsLoaded(map, maps, search.data.polygon, search.data.multiPolygon)
                          }
                        >
                          {mapMode == 'Listings' &&
                            !visibleOTAListings.loading &&
                            (visibleOTAListings.data?.length <= 50 ||
                              zoom > CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD) &&
                            otaMarkers}
                          {mapMode == 'Listings' &&
                          !visibleListings.loading &&
                          (visibleListings.data.length <= 50 ||
                            zoom > CLUSTER_POINTER_ZOOM_LEVEL_THRESHOLD) &&
                          clusterMarkers
                            ? markers
                            : clusterMarkers}
                          {!isTailoredRegionAnimationShown && tailoredRegionRedirectionMarkers}
                        </GoogleMapReact>
                      </>
                    )}

                    {hoveredNeighbourhood && (
                      <div
                        style={{
                          position: 'absolute',
                          top: `${hoveredNeighbourhoodPosY}px`,
                          left: `${hoveredNeighbourhoodPosX}px`,
                          zIndex: 4,
                        }}
                      >
                        <NeighbourhoodDataCard
                          listings={hoveredNeighbourhood?.listings}
                          currency={currency}
                          width={neighbourhoodTooltipWidth}
                          height={neighbourhoodTooltipHeight}
                          isUserAllowed={isUserAllowed}
                          multipleMarkersCallLoading={multipleMarkersCallLoading}
                          user={user}
                          isLoggedIn={isLoggedIn}
                          setLoginModalOpen={setLoginModalOpen}
                          setShowSearchCreditDeductWarningModal={
                            setShowSearchCreditDeductWarningModal
                          }
                          setSubscriptionModalOpen={setSubscriptionModalOpen}
                        />
                      </div>
                    )}

                    {!search.loading && active.list && (
                      <div style={{ height: '100%' }}>
                        <DataGrid
                          sortingOrder={['desc']}
                          className={classes.tableRoot}
                          rows={listViewData}
                          columns={listViewCols}
                          disableColumnFilter={true}
                          disableColumnMenu={true}
                          initialState={{
                            sorting: {
                              sortModel: [{ field: 'avgRevenue', sort: 'desc' }],
                            },
                          }}
                        />
                      </div>
                    )}
                  </Paper>
                  {(isUserAllowed && multipleMarkersCallLoading) || listings.loading ? (
                    <div
                      style={{
                        width: '100%',
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <CircularProgress style={{ marginBottom: 10, marginTop: -5 }} />
                    </div>
                  ) : (
                    <div
                      style={{
                        width: '100%',
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <DownloadCSVButton />
                    </div>
                  )}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
      </Grid>
      {searchLimitAlertBox && (
        <AlertBox setSearchLimitAlertBox={setSearchLimitAlertBox} matches={matches} />
      )}

      <Modal
        open={openTop10ManagerModal}
        onClose={() => {
          setOpenTop10ManagerModal(false);
        }}
      >
        <Container>
          <Box
            sx={{
              background: '#fff',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxHeight: '90vh',
              overflow: 'auto',
            }}
          >
            {listings.loading ? (
              <LoadingCard height={150} />
            ) : (
              <Top10ManagerCard
                isDisabled={isDisabled}
                listings={listings}
                currentMarket={`${search.data.name}`}
                currency={currency}
                multipleMarkersCallLoading={multipleMarkersCallLoading}
                handleOnSampleClick={handleOnSampleClick}
              />
            )}
          </Box>
        </Container>
      </Modal>

      {user && user.userDescription !== 'Trial' && (
        <ConfirmUnlockRegionModal
          open={!isUserAllowed && showSearchCreditDeductWarningModal}
          onConfirm={() => {
            setShowSearchCreditDeductWarningModal(false);
            getMarkers(true, 1);
            // temp market making screen
            // setIsMarketModalOn(true);
          }}
          onCancel={() => setShowSearchCreditDeductWarningModal(false)}
          message="Would you like to unlock this market? (Please note this will deduct 1 market credit.)"
        />
      )}

      {extraCreditDeductModal && (
        <ConfirmUnlockRegionModal
          open={extraCreditDeductModal}
          _onClose={() => setExtraCreditDeductModal(false)}
          onConfirm={() => {
            deductCredits();
            setExtraCreditDeductModal(false);
          }}
          onCancel={() => {
            exportIndividualListings(false, true);
            setExtraCreditDeductModal(false);
          }}
          message={`Please note that you can export only 10,000 listings as complementary with your current subscription. Exporting all ${
            listings.data.length
          } listings will deduct ${creditsToBeDeducted -
            1} more market credits. (For markets with greater than 10,000 listings, 1 additional market credit will be deducted for exporting each additional 20,000 listings) ${
            user.credits !== 0 && user.credits >= creditsToBeDeducted - 1
              ? ''
              : ' Add more credits.'
          }`}
          buttonNames={
            user.credits !== 0 && user.credits >= creditsToBeDeducted - 1
              ? ['Export only 10,000 listings', 'Export all listings']
              : ['Export only 10,000 listings', 'Add credits']
          }
        />
      )}

      {confirmSaveCountryPlanMarketModalOpen && (
        <ConfirmUnlockRegionModal
          open={confirmSaveCountryPlanMarketModalOpen}
          onConfirm={async () => {
            const res = await handleConfirmSaveCountryPlanMarket();
            setConfirmSaveCountryPlanMarketModalOpen(false);
            handleSaveCountryPlanMarketApiResponse(res);
          }}
          onCancel={() => setConfirmSaveCountryPlanMarketModalOpen(false)}
          message="Would you like to save this market to your search?"
          buttonNames={['Cancel', 'Save']}
          reverseButton={true}
          showLoader={true}
        />
      )}

      {extraExportCreditsLoading && (
        <Backdrop
          sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
          open={extraExportCreditsLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      {extraExportError && (
        <Modal open={extraExportError} onClose={() => setExtraExportError(false)}>
          <Box sx={{ ...ErrorStyle, width: 400 }}>
            <Typography variant="h5">
              You don't have enough credits, please purchase some credits.
            </Typography>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default InsightsDashboard;
